import { useTaskFormik } from "@timenotes/shared/src/features/project-board"
import { Button } from "antd"
import TextField from "components/timenotes/fields/text-field"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { Form, FormikProvider } from "formik"

interface NewTaskFormContainerProps {
  formik: ReturnType<typeof useTaskFormik>
  onHide(): void
}

const NewTaskFormContainer = (props: NewTaskFormContainerProps) => {
  const {
    formik,
    onHide,
  } = props

  return (
    <OutsideAlerter
      onClick={onHide}
    >
      <NewTaskForm 
        formik={formik}
        onHide={onHide}
      />
    </OutsideAlerter>
  )

}

interface NewTaskFormProps extends NewTaskFormContainerProps {}

const NewTaskForm = (props: NewTaskFormProps) => {
  const {
    formik,
    onHide,
  } = props

  return (
    <FormikProvider value={formik}>
      <Form>
        <TextField
          name="name"
          autoFocusPopover={true}
          autoFocus={true}
          placeholder="Task name"
        />

        <div
          style={{
            marginTop: '15px',
            display: 'flex',
            gap: '5px',
          }}
        >
          <Button
            onClick={onHide}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            loading={formik.isSubmitting}
            onClick={formik.submitForm}
          >
            Create
          </Button>

        </div>
      </Form>
    </FormikProvider>
  )
}



export default NewTaskFormContainer